import { h, Component } from 'preact'
import globals from '../../utils/globals'
import RelatedTopicsList from './RelatedTopicsList'
import { InstantSearch, Configure } from 'react-instantsearch-dom'
import algoliasearch from 'algoliasearch/lite'
import { Credentials, getSearchToken } from '../../services/algoliaService'
import { getFilters } from '../algolia/components/Search'

interface Props {
  pageSize: string
  widgetTitle: string
}

interface State {
  clientId: string
  token: string
  hiddenCategories: number[]
}

class RelatedTopics extends Component< Props, State > {
  communityId: string
  topicId: string
  topicTitle: string

  constructor () {
    super()
    this.communityId = globals('communityId')
    this.topicId = window.inSidedData.content.topic.id
    this.topicTitle = window.inSidedData.content.topic.title
    this.cb = this.cb.bind(this)
  }

  cb (data: Credentials) {
    this.setState({
      clientId: data.client_id,
      token: data.token,
      hiddenCategories: data.hiddenCategories
    })
  }

  componentDidMount () {
    getSearchToken(this.cb)
  }

  render (props: Props, state: State) {
    if (!state.clientId || !state.token) return null
    return (
      <div>
        <InstantSearch
          searchClient={algoliasearch(state.clientId, state.token)}
          indexName={this.communityId}
        >
          <Configure
            queryType='prefixNone'
            query={this.topicTitle}
            hitsPerPage={parseInt(props.pageSize) + 1}
            removeWordsIfNoResults='allOptional' optionalWords={this.topicTitle}
            analyticsTags={['destination', 'related']}
            filters={getFilters({ hiddenCategories: state.hiddenCategories })}
          />
          <RelatedTopicsList topicId={this.topicId} totalItemCount={props.pageSize} widgetTitle={props.widgetTitle} />
        </InstantSearch>
      </div>
    )
  }
}

export default RelatedTopics
